import React from 'react';
import MUIDialog, {
  DialogProps as MUIDialogProperties,
} from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export interface DialogProperties extends MUIDialogProperties {
  titleNode?: React.ReactNode;
  content: React.ReactNode;
  actions: React.ReactNode;
  tabs?: React.ReactNode;
}

const Dialog = ({
  titleNode, content, actions, tabs, ...properties
}: DialogProperties) => (
  <MUIDialog
    aria-labelledby="dialog-title"
    aria-describedby="dialog-description"
    {...properties}
  >
    { titleNode && (
    <DialogTitle variant="h4" component="h5" id="dialog-title">
      {titleNode}
    </DialogTitle>
    )}
    {tabs}
    <DialogContent>
      <DialogContentText component="div" id="dialog-description">
        {content}
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      {actions}
    </DialogActions>
  </MUIDialog>
);

export default Dialog;
